import * as Sentry from '@sentry/react';

export const initSentry = () => {
  Sentry.init({
    ...(window?.s4cConfig?.sentry || {}),
    integrations: [
      new Sentry.BrowserTracing(),
      new Sentry.Replay({
        maskAllText: false,
        blockAllMedia: false,
        maskAllInputs: true,
      }),
    ],
    beforeSend(event: any) {
      if (event.level === 'info') {
        return null;
      }
      return event;
    },
  });
};

export default initSentry;
